module.exports = __webpack_public_path__ + "static/media/dog2.8268b681.jpg";